import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Notification } from '../interfaces/notification.interface';

@Injectable()
export class NotificationService {
  constructor() { }

  private notify: Subject<Notification> = new Subject<Notification>();

  /**
   * Show the notification
   * @param  {Notification} data
   * @returns void
   */
  setNotification(data: any): void {
    this.notify.next(data);
  }
  /**
   * To listen the notification
   * @returns Observable
   */
  getNotification(): Observable<Notification> {
    return this.notify.asObservable();
  }
  /**
   * create a notification
   * @param  {string} title
   * @param  {string} content
   * @param  {string} type
   * @param  {number} timeout?
   * @returns void
   */
  createNotification(title: string, content: string, type: string, timeout?: number, alwaysVisible?: boolean): void {
    const notificationData: Notification = {
      title: title,
      content: content,
      type: type,
      timeout: timeout || 3000,
      alwaysVisible: alwaysVisible || false
    };
    // Triggering the notification to show
    this.setNotification(notificationData);
  }
}
